<!-- 验证码Dialog -->
<template>
  <Dialog
    :class="$i18n.locale"
    :visible.sync="showCaptchaDialog"
    :title="$t('identify.title')"
    :show-close="true"
    @close="closeCaptcha(true)"
    @touchmove.native.prevent
  >
    <!-- 验证码输入情况 -->
    <div v-if="!showFrequently" class="content">
      <!-- 图片验证码 -->
      <div :class="{ 'content-code': true, loading: getCaptchaLoading }" @click="refreshCode">
        <img class="image-code" :src="captchaCodeUrl" />

        <img class="refresh-icon" src="@img/icon_refresh.png" alt="" />
      </div>
      <!-- 输入框 -->
      <div class="input-box">
        <CaptchaInput
          :class="{
            input_item: true,
            active: captchaValue[index],
          }"
          v-for="(item, index) in codeNumber"
          :key="index"
          v-model="captchaValue[index]"
          @focus="(ev) => handleFocus(index, ev)"
          @input="(ev) => handleInput(index, ev)"
          @delete="(ev) => handleDelete(index, ev)"
          ref="inputs"
        />
      </div>
      <!-- 提示 -->
      <div class="captcha-tips regular">{{ verifyTips }}</div>
      <!-- 提交类型-按钮 -->
      <div
        :class="{
          medium: true,
          'captcha-btn': true,
          'disabled-btn': submitType === 'disabled',
          'loading-btn': submitType === 'loading',
        }"
        @click="verifyCode"
      >
        <img
          class="loading-icon"
          v-show="submitType === 'loading'"
          src="@img/icon_loading.png"
          alt=""
        />
        {{ $t('identify.submit') }}
      </div>
      <!--  -->
    </div>
    <!-- 错误情况 -->
    <div v-else class="abnormal">
      <div class="abnormal-content">
        <img class="icon" src="@img/icon_error.png" alt="icon_error" />
        <p class="text medium">{{ $t('identify.frequently') }}</p>
      </div>
      <!-- 提交类型-按钮 -->
      <div slot="footer" class="abnormal-submit" @click="closeCaptcha(true)">
        {{ $t('game.confirm') }}
      </div>
    </div>
  </Dialog>
</template>

<script>
const defaultCodeUrl = require('@img/default_code.png')
import CaptchaInput from './captchaInput.vue'
import { getCaptcha } from '@/api/index.js'
import { verifyCaptcha } from '@/api/index'
export default {
  name: 'CaptchaDialog',
  props: {
    gameId: {
      type: Number,
      default: 0,
    },
    captchaRequestId: {
      type: String,
      default: '',
      required: true,
    },
  },
  components: {
    CaptchaInput,
  },
  data() {
    return {
      // 是否验证频繁，是否显示频繁提示框
      showFrequently: false,
      showCaptchaDialog: false,
      getCaptchaLoading: true,
      captchaCodeUrl: defaultCodeUrl,
      codeNumber: 4,
      captchaValue: new Array(4).fill(''),
      verifyTips: '',
      submitType: 'disabled', //三个状态 button, loading, disabled
    }
  },
  watch: {
    captchaValue: {
      deep: true,
      handler(val) {
        // 判断验证码是否全部输入完成，如果是则提交验证
        if (val.every((item) => item !== '')) {
          this.submitType = 'button'
          this.verifyTips = ''
        } else {
          this.submitType = 'disabled'
        }
      },
    },
  },
  created() {
    this.getCaptchaCode()
  },

  mounted() {},

  methods: {
    /**
     * 关闭验证码弹窗
     *
     * @param obj 对象，包含关闭弹窗的标识信息
     */
    closeCaptcha(isClosePayConfirm) {
      this.showFrequently = false
      // 关闭验证码弹窗，并传递是否关闭支付弹窗
      this.$emit('closeCaptchaDialog', isClosePayConfirm)
    },
    /**
     * 刷新验证码
     *
     * 异步方法，用于刷新验证码，并重新获取验证码图片。
     *
     * @returns 无返回值
     */
    refreshCode() {
      if (this.submitType === 'loading') return

      this.getCaptchaLoading = true
      this.captchaValue = new Array(4).fill('')
      this.verifyTips = ''

      // TODO: 刷新验证码逻辑，暂时使用默认图片代替
      this.captchaCodeUrl = defaultCodeUrl
      this.getCaptchaCode()
    },
    /**
     * 获取验证码的方法
     *
     * @returns 无返回值
     */
    async getCaptchaCode() {
      try {
        const res = await getCaptcha({
          request_id: this.captchaRequestId,
          game_id: this.gameId,
        })
        this.showCaptchaDialog = true
        if (res.data.code === 15048) {
          this.showFrequently = true

          return
        }
        // TODO: 验证码图片 关闭验证码Loading
        this.getCaptchaLoading = false
        this.captchaCodeUrl = 'data:image/png;base64,' + res.data.data.captcha_code
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 异步验证验证码
     *
     * @returns 无返回值
     */
    async verifyCode() {
      // 如果验证正在加载，则直接返回
      if (this.submitType === 'loading') return

      // 如果验证按钮被禁用，则显示提示并返回
      if (this.submitType === 'disabled') {
        this.verifyTips = this.$t('identify.required')
        return
      }
      // 设置验证加载状态为true
      this.submitType = 'loading'

      // 将输入的验证码值连接成字符串
      const captcha_code = this.captchaValue.join('')

      try {
        // 调用验证验证码的API
        const res = await verifyCaptcha({
          request_id: this.captchaRequestId,
          game_id: this.gameId,
          captcha_code,
        })
        // 设置验证加载状态为false
        this.submitType = 'button'
        // 如果验证码验证成功
        if (res.data.code === 1) {
          this.$emit('success')
          this.closeCaptcha(false)
          // 1: 验证码成功
          this.$emit('verifyCaptchaAfter', 1)
          return
        }
        // 如果验证码验证失败，触发自定义事件
        this.$emit('verifyCaptchaAfter', 2)
        // 刷新验证码
        this.refreshCode()
        // 根据返回码显示不同的提示信息
        // 2: 验证码失败
        if (res.data.code === 15049) {
          this.verifyTips = this.$t('identify.expired')
        }

        if (res.data.code === 15036) {
          this.verifyTips = this.$t('identify.error')
        }
      } catch (error) {
        // 打印错误信息
        console.log(error)
        // 设置验证加载状态为false
        this.submitType = 'button'
      }
    },
    handleFocus(index) {
      if (!this.captchaValue[index]) {
        const canInputIndex = this.captchaValue.findIndex((v) => !v)
        this.$refs.inputs[canInputIndex].focus()
      }
    },
    handleInput(index, val) {
      // 过滤非字母数字字符
      this.captchaValue[index] = val.replace(/[^a-zA-Z0-9]/g, '').slice(0, 1)

      // 自动聚焦到下一个输入框
      if (this.captchaValue[index] && index < this.codeNumber - 1) {
        this.$refs.inputs[index + 1].focus()
      }
    },
    handleDelete(index) {
      console.log('delete', index)
      // 如果当前输入框为空且不是第一个，删除时聚焦到前一个输入框
      if (!this.captchaValue[index] && index > 0) {
        this.$refs.inputs[index - 1].focus()
      }
    },
  },
}
</script>
<style scoped lang="less">
//
.content-code {
  position: relative;
  width: 208px;
  height: 62px;
  font-size: 0;
  margin: 0 auto;
  border: 1px solid #a2a9b0;
  border-radius: 4px;
  .image-code {
    width: 100%;
    height: 100%;
  }
  .refresh-icon {
    position: absolute;
    right: -46px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: auto;
    cursor: pointer;
  }
}
.input-box {
  display: flex;
  justify-content: space-evenly;
  .input_item {
    background: transparent;
    border: none;
    border-bottom: 4px solid #878d96;
    outline: none;
    width: 60px;
    text-align: center;
    font-size: 40px;
    height: 80px;
    color: #010000;
    font-weight: bolder;
    caret-color: #000;
    &.active {
      border-bottom: 4px solid #1bc263;
    }
  }
}

.captcha-tips {
  width: 100%;
  height: 32px;
  margin-top: 5px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #f4271c;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
}

.captcha-btn {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #1bc263;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
}
.content .disabled-btn {
  opacity: 0.7;
}
.content .loading-btn {
  opacity: 0.7;
  cursor: not-allowed;
  .loading-icon {
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
    margin: 8px;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}

// 异常
.abnormal {
  width: 100%;
  .abnormal-content {
    width: 100%;
    height: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    background: #f2f4f8;
    border-radius: 8px;
    .icon {
      width: 64px;
      height: 64px;
      margin-bottom: 15px;
    }
    .text {
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      text-align: center;
    }
  }
  .abnormal-submit {
    width: 100%;
    height: 44px;
    background: #07c261;
    color: #fff;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 18px;
  }
}
</style>
